import api from "~/services/apis/antecipeApi";

// Rotas existentes 10–13 (spec §4.3 do login-rbac) + desativar/reativar (spec ux-wave §4.2).
export const listAdminCompanies = async ({ includeInactive = false } = {}) =>
  (await api.get("antecipeadmin/company", { params: includeInactive ? { includeInactive: true } : undefined })).data.data;
// city/uf (S5, opcionais): ausente = não muda; null = limpa.
const cityUf = ({ city, uf }) => ({ ...(city !== undefined ? { city } : {}), ...(uf !== undefined ? { uf } : {}) });
export const createCompany = async ({ name, cnpj, address, cep, meuplantao, ...rest }) =>
  (await api.post("antecipeadmin/company", { name, cnpj, address, cep, meuplantao, ...cityUf(rest) })).data.data;
// O update do BE não aceita meuplantao (o vínculo com o ME só nasce na criação).
export const updateCompany = async (id, { name, cnpj, address, cep, ...rest }) =>
  (await api.put(`antecipeadmin/company/${id}`, { name, cnpj, address, cep, ...cityUf(rest) })).data.data;
// Só Admin. O BE valida o motivo aparado (5..500); 409 COMPANY_ALREADY_INACTIVE / COMPANY_ALREADY_ACTIVE.
export const deactivateCompany = async (id, reason) =>
  (await api.patch(`antecipeadmin/company/${id}/deactivate`, { reason: String(reason || "").trim() })).data.data;
export const reactivateCompany = async (id) => (await api.patch(`antecipeadmin/company/${id}/reactivate`)).data.data;
